const renderMoreSelectedValues = (omittedValues) => `+${omittedValues.length}`;

export const multiSelectTagProps = {
  maxTagCount: 2,
  maxTagPlaceholder: renderMoreSelectedValues,
};

export const compactMultiSelectTagProps = {
  maxTagCount: 1,
  maxTagPlaceholder: renderMoreSelectedValues,
};
